<template>
   <div class="employee-tab-inner">
      <template v-if="permission == 2">
         <b-alert v-model="hasDraft" class="position-fixed fixed-top m-0 rounded-0" style="z-index: 2000;" variant="info" dismissible>System Alert : Draft data is waiting for your approval!</b-alert>
      </template>
      <b-alert v-model="draft_employee" class="position-fixed fixed-top m-0 rounded-0" style="z-index: 2000;" variant="info" dismissible>System Alert : This is a draft employee.</b-alert>



      <b-overlay :show="showoverlay" rounded="sm">
         <b-card no-body class="border-0 bg-transparent no-shadow employee-tab-bg">
            <div class="d-inline-block w-100" v-if="fdata.employee_id > 0">
               <!-- if employee exist -->
               <div class="row pt-4" >
                  <div class="col-md-6">
                     <div class="clearfix company-form-container h-100">
                        <div class="row no-gutters py-3">
                           <div class="col-sm-6 px-3 company-form-box-title">Personal Information</div>
                           <template  v-if="permission > 1">
                              <div class="col-sm-6 px-3 cursor-pointer text-right company-form-box-title"><a @click="trz_display()" class="edit-icon"><i class="fa fa-pencil-alt"></i></a></div>
                           </template>
                        </div>
                        <div>
                           <dl class="row px-3">
                              <dt class="col-sm-6">Name</dt><dd class="col-sm-6">{{xdata.name}}</dd>

                              <dt class="col-sm-6">Nationality</dt><dd class="col-sm-6">{{xdata.nationality}}</dd>

                              <template v-if="xdata.date_of_birth != '0000-00-00'">
                                 <dt class="col-sm-6">Date of Birth<span class="custom-date-indicator">(YYYY-MM-DD)</span></dt>
                                 <dd class="col-sm-6">{{ xdata.date_of_birth }}</dd>
                              </template>

                              <dt class="col-sm-6">Gender</dt><dd class="col-sm-6">{{xdata.gender}}</dd>

                              <template v-if="xdata.nid != ''">
                                 <dt class="col-sm-6">NID No.</dt>
                                 <dd class="col-sm-6">
                                    {{xdata.nid}}
                                    <template v-if="xdata.nid_scan != ''">
                                       <b-link class="px-4 py-2 mb-4 d-inline-block cmpny-dwnld-btn" @click="downloadFileContent('/images/employee/' + fdata.company_id + '/' + xdata.nid_scan)"><img v-bind:src="$api_url+'/images/pdf.png'"  class="img-fluid mr-3" height="19px" width="16px" />Download NID No.</b-link>
                                    </template>
                                 </dd>
                              </template>

                              <template v-if="xdata.passport != ''">
                                 <dt class="col-sm-6">Passport No.</dt>
                                 <dd class="col-sm-6">
                                    {{xdata.passport}}
                                    <template v-if="xdata.passport_scan != ''">
                                       <b-link class="px-4 py-2 mb-4 d-inline-block cmpny-dwnld-btn" @click="downloadFileContent('/images/employee/' + fdata.company_id + '/' + xdata.passport_scan)"><img v-bind:src="$api_url+'/images/pdf.png'"  class="img-fluid mr-3" height="19px" width="16px" />Download Passport No. Copy</b-link>
                                    </template>
                                 </dd>
                              </template>


                              <template v-if="xdata.marital_status != ''">
                                 <dt class="col-sm-6">Marital Status</dt>
                                 <dd class="col-sm-6">{{xdata.marital_status}}</dd>
                              </template>
                           </dl>
                        </div>
                     </div>
                  </div>


                  <div class="col-md-6">
                     <div class="clearfix company-form-container h-100" style="min-height:282px;">
                        <div class="row no-gutters py-3">
                           <div class="col-sm-6 px-3 company-form-box-title">Contact Information</div>
                           <template  v-if="permission > 1">
                              <div class="col-sm-6 px-3 cursor-pointer text-right company-form-box-title"><button @click="trz_display()" class="edit-icon"><i class="fa fa-pencil-alt"></i></button></div>
                           </template>
                        </div>
                        <div>
                           <dl class="row px-3">
                              <template v-if="xdata.phone != null && xdata.phone != ''">
                                 <dt class="col-sm-6">Mobile Number</dt>
                                 <dd class="col-sm-6">{{formatPhoneNumber(xdata.phone)}}</dd>
                              </template>
                              <template v-if="xdata.email != null && xdata.email != ''">
                                 <dt class="col-sm-6">Email Address</dt>
                                 <dd class="col-sm-6">{{xdata.email}}</dd>
                              </template>
                              <dt class="col-sm-6">Present Address</dt>
                              <dd class="col-sm-6">{{xdata.address}}</dd>
                              <template v-if="xdata.emergency_contact != ''">
                                 <dt class="col-sm-6">Emergency Contact</dt>
                                 <dd class="col-sm-6">{{xdata.emergency_contact}}</dd>
                              </template>
                           </dl>
                        </div>
                     </div>
                  </div>
               </div>

               <div class="row pt-4" >
                  <div class="col-md-6">
                  <div class="clearfix company-form-container pb-2 h-100">
                     <div class="row no-gutters py-3">
                        <div class="col-sm-6 px-3 company-form-box-title">Tax Information</div>
                        <template  v-if="permission > 1">
                           <div class="col-sm-6 px-3 cursor-pointer text-right company-form-box-title"><button @click="trz_display()" class="edit-icon"><i class="fa fa-pencil-alt"></i></button></div>
                        </template>
                     </div>
                     <div>
                        <dl class="row px-3">
                           <template v-if="xdata.etin != ''">
                              <dt class="col-sm-6">e-TIN Number</dt>
                              <dd class="col-sm-6">
                                 {{xdata.etin}}
                                 <template v-if="xdata.etin_scan != ''">
                                    <b-link class="px-4 py-2 mb-4 d-inline-block cmpny-dwnld-btn" @click="downloadFileContent('/images/employee/' + fdata.company_id + '/' + xdata.etin_scan)"><img v-bind:src="$api_url+'/images/pdf.png'"  class="img-fluid mr-3" height="19px" width="16px" />Download e-TIN certificate</b-link>
                                 </template>
                              </dd>
                           </template>
                           <template v-if="xdata.date_of_etin != '0000-00-00'">
                              <dt class="col-sm-6">e-TIN Registration Date<span class="custom-date-indicator">(YYYY-MM-DD)</span></dt>
                              <dd class="col-sm-6">{{ xdata.date_of_etin }}</dd>
                           </template>
                           <dt class="col-sm-6">Residency</dt>
                           <dd class="col-sm-6">{{xdata.residency}}</dd>
                           <dt class="col-sm-6">Tax payer</dt>
                           <dd class="col-sm-6">
                              <div v-if="xdata.is_freedom_fighter == 1">Gazetted Freedom Fighter</div>
                              <div v-if="xdata.is_july_freedom_fighter == 1">Gazetted July Mass Uprising Fighters</div>
                              <div v-if="xdata.is_disabled == 1">Disabled Individual</div>
                              <div v-if="xdata.is_disabled_parent > 0">Parent/ Guardian for Each Disabled Individual ({{ xdata.is_disabled_parent }})</div>
                           </dd>
                        </dl>
                     </div>
                  </div>
                  </div>
                  <div class="col-md-6">
                     <div class="clearfix company-form-container h-100">
                           <div class="row no-gutters py-3"> <!-- Mustafijur: Removed mb-3 border-bottom 13-04-2026 -->
                              <div class="col-sm-6 px-3 company-form-box-title">HR Information</div>
                              <template  v-if="permission > 1">
                                 <div class="col-sm-6 px-3 cursor-pointer text-right company-form-box-title"><a href="#" @click="trz_display_hr_info()" class="edit-icon"><i class="fa fa-pencil-alt"></i></a></div>
                              </template>
                           </div>
                           <div>
                              <dl class="row px-3">
                                 <template v-if="xdata.department_id > 0">
                                    <dt class="col-sm-6">Department</dt>
                                    <dd class="col-sm-6">
                                       <template v-for="dept in department">
                                          <template v-if="dept.value == xdata.department_id">{{dept.text}}</template>
                                       </template>
                                    </dd>
                                 </template>
                                 <template v-if="xdata.employee_type_id > 0">
                                    <dt class="col-sm-6">Employee Type</dt>
                                    <dd class="col-sm-6">
                                       <template v-for="type in employee_type">
                                          <template v-if="type.value == xdata.employee_type_id">{{type.text}}</template>
                                       </template>
                                    </dd>
                                 </template>
                                 <template v-if="xdata.jobposition_id > 0">
                                    <dt class="col-sm-6">Job Position</dt>
                                    <dd class="col-sm-6">
                                       <template v-for="jp in jobposition">
                                          <template v-if="jp.value == xdata.jobposition_id">{{jp.text}}</template>
                                       </template>
                                    </dd>
                                 </template>
                                 <template v-if="xdata.branch_id > 0">
                                    <dt class="col-sm-6">Work Location</dt>
                                    <dd class="col-sm-6">
                                       <template v-for="br in branch">
                                          <template v-if="br.value == xdata.branch_id">{{br.text}}</template>
                                       </template>
                                    </dd>
                                 </template>
                                 <template v-if="xdata.manager_id > 0">
                                    <dt class="col-sm-6">Reporting Manager</dt>
                                    <dd class="col-sm-6">
                                       <template v-for="mnr in manager">
                                          <template v-if="mnr.value == xdata.manager_id">{{mnr.text}}</template>
                                       </template>
                                    </dd>
                                 </template>
                                 <!-- <template v-if="xdata.leave_policy_id > 0">
                                    <dt class="col-sm-6">Leave Policy</dt>
                                    <dd class="col-sm-6">
                                       <template v-for="leavepolicy in leave_policies">
                                          <template v-if="leavepolicy.value == xdata.leave_policy_id">{{leavepolicy.text}}</template>
                                       </template>
                                    </dd>
                                 </template> -->
                                 <template v-if="xdata.leave_policy_id > 0 || xdata.roster_leave_policy_id > 0">
                                    <dt class="col-sm-6">Leave Policy</dt>
                                    <!-- asfaq 21 june 2026 -->
                                    <dd class="col-sm-6" v-if="addons.includes('LeaveAttendances')">
                                       <template v-for="leavepolicy in leave_policies">
                                          <template v-if="leavepolicy.value == xdata.leave_policy_id">{{leavepolicy.text}}</template>
                                       </template>
                                    </dd>
                                    <dd class="col-sm-6" v-if="addons.includes('Roster')">
                                       <template v-for="leavepolicy in roster_leave_policies">
                                          <template v-if="leavepolicy.value == xdata.roster_leave_policy_id">{{leavepolicy.text}}</template>
                                       </template>
                                    </dd>
                                    <!-- asfaq 21 june 2026 -->
                                 </template>
                                 <template v-if="xdata.employee_code != ''">
                                    <dt class="col-sm-6">Employee Code</dt>
                                    <dd class="col-sm-6">{{xdata.employee_code}}</dd>
                                 </template>
                                 <template v-if="date_of_joining != 'Invalid date'">
                                    <dt class="col-sm-6">Joining Date<span class="custom-date-indicator">(YYYY-MM-DD)</span></dt>
                                    <dd class="col-sm-6">{{ xdata.date_of_joining }}</dd>
                                 </template>
                                 <template>
                                    <dt class="col-sm-6">Leaving Date<span class="custom-date-indicator">(YYYY-MM-DD)</span></dt>
                                    <dd class="col-sm-6">{{ xdata.date_of_leaving }}</dd>
                                 </template>
                              </dl>
                           </div>
                     </div>
                  </div>
               </div>


               <div class="row pt-4">
               <!-- Todays Changes  -->
                  <div class="col-md-6">
                     <div class="clearfix company-form-container h-100">
                           <employee-bank-info v-if="this.permission > 1" :flg="1" :bn="this.xdata.name"></employee-bank-info>
                           <employee-bank-info v-else :flg="0" :bn="this.xdata.name"></employee-bank-info>
                        </div>
                  </div>
                  <!-- Todays Changes End  -->

                  <div class="col-md-6">
                     <div class="clearfix company-form-container h-100">
                           <div class="row no-gutters py-3">
                              <div class="col-sm-6 px-3 company-form-box-title">Other Information</div>
                              <template  v-if="permission > 1">
                                 <div class="col-sm-6 px-3 cursor-pointer text-right company-form-box-title"><a href="#" @click="trz_display()" class="edit-icon"><i class="fa fa-pencil-alt"></i></a></div>
                              </template>
                           </div>
                           <div>
                              <dl class="row px-3">
                                 <!-- v-if="fdata.department_id > 0" -->
                                 <template>
                                    <dt class="col-sm-3">Blood Group</dt>
                                    <dd class="col-sm-9">
                                       <template v-if="xdata.blood_group != ''">
                                          {{xdata.blood_group}}
                                       </template>
                                    </dd>
                                 </template>
                                 <!-- v-if="fdata.jobposition_id > 0" -->
                                 <template >
                                    <dt class="col-sm-3">Religion</dt>
                                    <dd class="col-sm-9">
                                       <template v-if="xdata.religion != ''">
                                          {{xdata.religion}}
                                       </template>
                                    </dd>
                                 </template>
                                 <template>
                                    <dt class="col-sm-3">Disability</dt>
                                    <dd class="col-sm-9">
                                       <template v-if="xdata.disability != '' ">
                                          {{xdata.disability}}
                                       </template>
                                    </dd>
                                 </template>

                              </dl>
                           </div>
                     </div>
                  </div>
               </div>

               <div class="row pt-4" >
                     <approver-approvers :single="true" :employee_ids="[fdata.employee_id]"></approver-approvers>

                     <!-- Spouse Info start-->
                     <div class="col-md-6">
                        <div class="clearfix company-form-container h-100">
                              <employee-spouse-info :flg="1" :bn="this.xdata.name"></employee-spouse-info>
                        </div>
                     </div>
                     <!-- Spouse Info-->
                     <div class="col-md-6">
                        <div class="clearfix company-form-container h-100">
                              <employee-child-info :flg="1"></employee-child-info>
                        </div>
                     </div>
               </div>
               <div class="row pt-4">
                     <div class="col-md-6">
                     <div class="clearfix company-form-container h-100">
                           <employee-custom-attribute ></employee-custom-attribute>
                     </div>
                     </div>
                     <!-- Cost Center start-->
                     <div class="col-md-6">
                     <div class="clearfix company-form-container h-100">
                           <employee-cost-center ></employee-cost-center>
                     </div>
                     </div>
                     <!-- Cost Center End-->
               </div>
               <template v-if="this.fdata.employee_id > 0">
                  <div class="row pt-4">
                     <div class="col-md-6">
                        <div class="clearfix company-form-container h-100">
                              <employee-nominee-info :company_id="this.fdata.company_id" :employeeid="this.fdata.employee_id"></employee-nominee-info>
                           </div>
                     </div>
                     <div class="col-md-6">
                        <div class="clearfix company-form-container h-100">
                           <employee-payment-bank-info :company_id="this.fdata.company_id" :employee_id="this.fdata.employee_id"></employee-payment-bank-info>
                        </div>
                     </div>
                  </div>

               </template>
            </div>

            <div class="d-inline-block w-100" v-else>
               <b-card title="Employee Profile Details">
               <div class="" >
                  <b-form @submit.stop.prevent="onSubmit" class="w-100">
                     <input type="hidden" v-model="fdata.employee_id" name="employee_id">
                     <div class="clearfix">
                        <div>
                            <div>
                                <div class="row">
                                    <div class="col-7">
                                        <div class="card susd-card2">
                                            <div class="card-title pt-3 pb-3 pl-4 susd radius susd-head1">Personal Information</div>
                                            <div class="card-body px-4 pb-5">
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <label class="invest_head">Full Name *</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <b-form-group  id="name-group" class="required-field" label-for="name" >
                                                            <b-form-input id="name"  name="name" v-model="fdata.name" :disabled="disabled" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                                                            <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <label class="invest_head">Nationality *</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <b-form-group id="nationality-group" class="required-field" label-for="nationality">
                                                            <b-form-select id="nationality" name="nationality" v-model="fdata.nationality" v-validate="{ required: true }" :options="nationality" :state="validateState('nationality')" aria-describedby="nationality-feedback" data-vv-as="Nationality"></b-form-select>
                                                            <b-form-invalid-feedback id="nationality-feedback">{{ veeErrors.first('nationality') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <!-- AbdullahFixed added * here  -->
                                                        <label class="invest_head">Date of Birth [YYYY-MM-DD] *</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <input type="hidden" v-model="fake"/>
                                                        <b-form-group id="date_of_birth-group" class="required-field" label-for="date_of_birth">
                                                            <b-input-group class="mb-3">
                                                                <b-form-input id="date_of_birth" name="date_of_birth" v-model="fdata.date_of_birth" v-validate="{required:true, date_format: 'yyyy-MM-dd' }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('date_of_birth')" aria-describedby="date_of_birth-feedback" data-vv-as="Date of Birth"></b-form-input>
                                                                <b-input-group-prepend>
                                                                    <b-form-datepicker id="date_of_birth" :max="date_max" button-only right locale="en-US" v-model="fdata.date_of_birth"></b-form-datepicker>
                                                                </b-input-group-prepend>
                                                                <b-form-invalid-feedback id="date_of_birth-feedback">{{ veeErrors.first('date_of_birth') }}</b-form-invalid-feedback>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <label class="invest_head">NID No.</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <b-form-group id="nid-group" class="" label-for="nid">
                                                            <b-form-input id="nid" name="nid" v-model="fdata.nid" ></b-form-input>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <label class="invest_head">Scanned copy of NID No.</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <div class="row">
                                                            <div class="col-sm-12">
                                                                <b-form-group id="form_nid_scan-group" label-for="form_nid_scan">
                                                                    <b-form-file id="form_nid_scan" @change="checkFileType($event , 'form_nid_scan' , ['.jpg','.png','.gif','.pdf'])"  v-model="form_nid_scan" accept=".jpg, .png, .gif, .pdf"  placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." aria-describedby="form_nid_scan-feedback" data-vv-as="Scanned copy of NID No."></b-form-file>
                                                                </b-form-group>
                                                            </div>
                                                            <div class="col-sm-2 align-self-center mt-2" v-if="fdata.nid_scan">
                                                                <b-link @click="downloadFileContent('/images/employee/'+ fdata.company_id + '/' + fdata.nid_scan)">
                                                                    <b-icon icon="download" scale="2"></b-icon>
                                                                </b-link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <label class="invest_head">Passport No.</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <b-form-group id="passport-group" class="" label-for="passport">
                                                            <b-form-input id="passport" name="passport" v-model="fdata.passport" ></b-form-input>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <label class="invest_head">Scanned copy of Passport No.</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <div class="row">
                                                            <div class="col-sm-12">
                                                                <b-form-group id="form_passport_scan-group" label-for="form_passport_scan"  class="passport-upload-full">
                                                                    <b-form-file @change="checkFileType($event , 'form_passport_scan' , ['.jpg','.png','.gif','.pdf'])" id="form_passport_scan" v-model="form_passport_scan" accept=".jpg, .png, .gif, .pdf"  placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." aria-describedby="form_passport_scan-feedback" data-vv-as="Scanned copy of Passport No."></b-form-file>
                                                                </b-form-group>
                                                            </div>
                                                            <div class="col-sm-2 align-self-center mt-2" v-if="fdata.passport_scan">
                                                                <b-link @click="downloadFileContent('/images/employee/'+ fdata.company_id + '/' + fdata.passport_scan)">
                                                                    <b-icon icon="download" scale="2"></b-icon>
                                                                </b-link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <!-- AbdullahFixed added * here  -->
                                                        <label class="invest_head">Gender *</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <b-form-group  id="gender-group" class="required-field" label-for="gender">
                                                            <b-form-select id="gender" name="gender" v-model="fdata.gender" :disabled="disabled" v-validate="{ required: true }" :options="gender" :state="validateState('gender')" aria-describedby="gender-feedback" data-vv-as="Gender"></b-form-select>
                                                            <b-form-invalid-feedback id="gender-feedback">{{ veeErrors.first('gender') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <label class="invest_head">Marital Status</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                         <b-form-group  id="marital_status-group" class="" label-for="marital_status">
                                                            <b-form-select id="marital_status" name="marital_status" v-model="fdata.marital_status" :disabled="disabled" :options="marital_status" ></b-form-select>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                            </div>
                                       </div>
                                    </div>
                                    <div class="col-5">

                                        <div class="">
                                            <div class="card susd-card2">
                                                <div class="card-title pt-3 pb-3 pl-4 susd radius susd-head1">Other Information</div>
                                                <div class="card-body px-4">
                                                    <div class="row">
                                                        <div class="col-md-3">
                                                            <label class="invest_head">Blood Group</label>
                                                        </div>
                                                        <div class="col-md-9">
                                                            <!-- Blood Group -->
                                                            <b-form-group id="blood_group_id-group" label-for="blood_group_id">
                                                                <b-form-select id="blood_group_id" name="blood_group_id" v-model="fdata.blood_group" :options="bloodGroop"></b-form-select>
                                                            </b-form-group>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-3">
                                                            <label class="invest_head">Religion</label>
                                                        </div>
                                                        <div class="col-md-9">
                                                            <!-- Religion -->
                                                            <b-form-group id="religion-group" label-for="Religion">
                                                                <b-form-select id="religion" name="religion" v-model="fdata.religion" :options="religion" ></b-form-select>
                                                            </b-form-group>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-3">
                                                            <label class="invest_head">Disability</label>
                                                        </div>
                                                        <div class="col-md-9">
                                                            <!-- Disability -->
                                                            <b-form-group  id="name-group" label-for="Disability" >
                                                                <b-form-input id="disability"  name="disability" v-model="fdata.disability" placeholder="Write disability"></b-form-input>
                                                            </b-form-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="mt-4">
                                            <div class="card susd-card2">
                                                <div class="card-title pt-3 pb-3 pl-4 susd radius susd-head1">HR Information</div>
                                                <div class="card-body px-4">
                                                    <div class="row">
                                                        <div class="col-md-3">
                                                            <label class="invest_head">Department</label>
                                                        </div>
                                                        <div class="col-md-9">
                                                            <b-form-group id="department_id-group" class="" label-for="department_id">
                                                                <b-input-group>
                                                                    <b-form-select id="department_id" name="department_id" v-model="fdata.department_id" :disabled="disabled_edit" :options="department"></b-form-select>
                                                                    <b-input-group-append v-if="draft_data['department_id'] && (xdata.department_id != 0)" v-b-tooltip.hover :title="department.find(department => department.id === xdata['department_id']).text">
                                                                        <b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon>
                                                                    </b-input-group-append>
                                                                    <b-input-group-append v-else-if="draft_data['department_id']">
                                                                        <b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon>
                                                                    </b-input-group-append>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-md-3">
                                                            <label class="invest_head">Employee Type</label>
                                                        </div>
                                                        <div class="col-md-9">
                                                            <b-form-group id="employee_type_id-group" class="" label-for="employee_type_id">
                                                                <b-input-group>
                                                                    <b-form-select id="employee_type_id" name="employee_type_id" v-model="fdata.employee_type_id" :disabled="disabled_edit" :options="employee_type"></b-form-select>
                                                                    <b-input-group-append v-if="draft_data['employee_type_id'] && (xdata.employee_type_id != 0)" v-b-tooltip.hover :title="employee_type.find(type => type.value === xdata['employee_type_id']).text">
                                                                        <b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon>
                                                                    </b-input-group-append>
                                                                    <b-input-group-append v-else-if="draft_data['employee_type_id']">
                                                                        <b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon>
                                                                    </b-input-group-append>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-md-3">
                                                            <label class="invest_head">Job Position</label>
                                                        </div>
                                                        <div class="col-md-9">
                                                            <b-form-group id="jobposition_id-group" class="" label-for="jobposition_id">
                                                                <b-input-group>
                                                                    <b-form-select id="jobposition_id" name="jobposition_id" v-model="fdata.jobposition_id" :disabled="disabled_edit" :options="jobposition"></b-form-select>
                                                                    <b-input-group-append v-if="draft_data['jobposition_id'] && (xdata.jobposition_id != 0)" v-b-tooltip.hover :title="jobposition.find(jobposition => jobposition.id === xdata['jobposition_id']).text">
                                                                        <b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon>
                                                                    </b-input-group-append>
                                                                    <b-input-group-append v-else-if="draft_data['jobposition_id']">
                                                                        <b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon>
                                                                    </b-input-group-append>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-3">
                                                            <label class="invest_head">Work Location</label>
                                                        </div>
                                                        <div class="col-md-9">
                                                            <b-form-group id="branch_id-group" class="" label-for="branch_id">
                                                                <b-input-group>
                                                                    <b-form-select id="branch_id" name="branch_id"
                                                                    v-model="fdata.branch_id" :options="branch"
                                                                    :disabled="disabled_edit"></b-form-select>
                                                                    <b-input-group-append
                                                                    v-if="draft_data['branch_id'] && (xdata.jobposition_id != 0)"
                                                                    v-b-tooltip.hover
                                                                    :title="branch.find(branch => branch.id === xdata['branch_id']).text"><b-icon
                                                                        icon="pencil-square"
                                                                        class="ml-1 mt-2"></b-icon></b-input-group-append>
                                                                    <b-input-group-append v-else-if="draft_data['branch_id']"><b-icon
                                                                        icon="pencil-square"
                                                                        class="ml-1 mt-2"></b-icon></b-input-group-append>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-3">
                                                            <label class="invest_head">Joining Date [YYYY-MM-DD]</label>
                                                        </div>
                                                        <div class="col-md-9">
                                                            <b-form-group id="date_of_joining-group" label-for="date_of_joining">
                                                                <b-input-group class="mb-3">
                                                                    <b-form-input id="date_of_joining" v-model="fdata.date_of_joining" type="text" placeholder="YYYY-MM-DD" autocomplete="off" @change="onContext"></b-form-input>
                                                                    <b-input-group-prepend>
                                                                    <b-form-datepicker v-model="fdata.date_of_joining" button-only right locale="en-US" aria-controls="example-input" @context="onContext"></b-form-datepicker>
                                                                    <span v-if="draft_data['date_of_joining']" v-b-tooltip.hover :title="xdata['date_of_joining']">
                                                                        <b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon>
                                                                    </span>
                                                                    </b-input-group-prepend>

                                                                </b-input-group>
                                                            </b-form-group>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-3">
                                                            <label class="invest_head">Employee Code</label>
                                                        </div>
                                                        <div class="col-md-9">
                                                            <b-form-group id="employee_code-group" label-for="employee_code">
                                                                <b-input-group>
                                                                    <b-form-input id="employee_code" class="radius-8" name="employee_code" v-model="fdata.employee_code" v-validate="{  min: 3 }" :state="validateState('employee_code')" aria-describedby="employee_code-feedback" data-vv-as="Employee Code"></b-form-input>
                                                                    <b-form-invalid-feedback id="employee_code-feedback">{{ veeErrors.first('employee_code') }}</b-form-invalid-feedback>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                       <div class="col-md-3">
                                                            <label class="invest_head">Leave Policy</label>
                                                        </div>
                                                        <div class="col-md-9">
                                                            <b-form-group id="leave_policy_id-group" class=""
                                                                label-for="leave_policy_id">
                                                                <b-input-group>
                                                                    <b-form-select id="leave_policy_id" name="leave_policy_id"
                                                                    v-model="fdata.leave_policy_id" :options="leave_policies"
                                                                    :disabled="disabled_edit"></b-form-select>
                                                                    <b-input-group-append
                                                                    v-if="draft_data['leave_policy_id'] && (xdata.leave_policy_id != 0)"
                                                                    v-b-tooltip.hover
                                                                    :title="leave_policies.find(leave_policies => leave_policies.value === xdata['leave_policy_id']).text"><b-icon
                                                                        icon="pencil-square"
                                                                        class="ml-1 mt-2"></b-icon></b-input-group-append>
                                                                    <b-input-group-append
                                                                    v-else-if="draft_data['leave_policy_id']"><b-icon
                                                                        icon="pencil-square"
                                                                        class="ml-1 mt-2"></b-icon></b-input-group-append>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="row mt-4">
                                    <div class="col-7">
                                        <div class="card susd-card2">
                                            <div class="card-title pt-3 pb-3 pl-4 susd radius susd-head1">Contact Information</div>
                                            <div class="card-body px-4">
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <label class="invest_head">Mobile Number</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <b-form-group id="phone-group" class="" label-for="phone">
                                                            <b-input-group prepend="+880">
                                                                <b-form-input id="phone" name="phone" v-model="fdata.phone" v-validate="{ min: 10 , max:10 }" :state="validateState('phone')" aria-describedby="phone-feedback" data-vv-as="Contact Number"></b-form-input>
                                                                <b-form-invalid-feedback id="phone-feedback">{{ veeErrors.first('phone') }}</b-form-invalid-feedback>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <label class="invest_head">Personal Email Address</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <b-form-group id="personal_email-group" class="" label-for="personal_email">
                                                            <b-form-input id="personal_email" name="personal_email" type="email" v-model="fdata.personal_email" v-validate="{ email: true }" :state="validateState('personal_email')" aria-describedby="email-feedback" data-vv-as="Email"></b-form-input>
                                                            <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <!-- AbdullahFixed added * here  -->
                                                        <label class="invest_head">Present Address *</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <b-form-group  id="address-group" class="required-field" label-for="address">
                                                            <b-form-textarea id="address" name="address" rows="3" max-rows="6" :disabled="disabled" no-resize v-model="fdata.address" v-validate="{required: true, min: 3 }" :state="validateState('address')" aria-describedby="address-feedback" data-vv-as="Address"></b-form-textarea>
                                                            <b-form-invalid-feedback id="address-feedback">{{ veeErrors.first('address') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <label class="invest_head">Emergency Contact</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <b-form-group  id="emergency_contact-group" label-for="emergency_contact">
                                                            <b-form-textarea id="emergency_contact" name="emergency_contact" rows="3" max-rows="6" :disabled="disabled" no-resize v-model="fdata.emergency_contact" :state="validateState('emergency_contact')" aria-describedby="emergency_contact-feedback" data-vv-as="Emergency Contact"></b-form-textarea>
                                                            <b-form-invalid-feedback id="emergency_contact-feedback">{{ veeErrors.first('emergency_contact') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <label class="invest_head">Email Address</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <b-form-group id="email-group"  class="" label-for="email">
                                                            <b-form-input id="email" name="email" type="email"  v-model="fdata.email" v-validate="{ email:true}" :state="validateState('email')" aria-describedby="email-feedback" data-vv-as="Email"></b-form-input>
                                                            <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-5">

                                        <div class="card susd-card2">
                                            <div class="card-title pt-3 pb-3 pl-4 susd radius susd-head1">Tax Information</div>
                                            <div class="card-body px-4">
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <label class="invest_head">e-TIN Number</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <b-form-group id="etin-group" label-for="etin">
                                                            <b-form-input id="etin" name="etin" v-model="fdata.etin" v-validate="{min: 12 , max:12}" :state="validateState('etin')" aria-describedby="etin-feedback" data-vv-as="eTin"></b-form-input>
                                                            <b-form-invalid-feedback id="etin-feedback">{{ veeErrors.first('etin') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <label class="invest_head">Scanned copy of e-TIN</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <b-form-group id="form_etin_scan-group" label-for="form_etin_scan">
                                                            <b-form-file @change="checkFileType($event , 'form_etin_scan' , ['.jpg','.png','.gif','.pdf'])" id="form_etin_scan" v-model="form_etin_scan" accept=".jpg, .png, .gif, .pdf"  placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." aria-describedby="form_etin_scan-feedback" data-vv-as="Scanned copy of eTIN"></b-form-file>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                                 <div class="row">
                                                    <div class="col-md-3">
                                                        <!-- AbdullahFixed added * here  -->
                                                        <label class="invest_head">Residency *</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <b-form-group id="residency-group" class="required-field" label-for="residency">
                                                            <b-form-select id="residency" name="residency" v-model="fdata.residency" v-validate="{ required: true }" :options="residency" :state="validateState('residency')" aria-describedby="residency-feedback" data-vv-as="Residency"></b-form-select>
                                                            <b-form-invalid-feedback id="residency-feedback">{{ veeErrors.first('residency') }}</b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <label class="invest_head">Tax Payer</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <b-form-checkbox id="is_freedom_fighter" v-model="fdata.is_freedom_fighter" name="is_freedom_fighter" value="1" unchecked-value="0">Gazetted Freedom Fighter</b-form-checkbox>
                                                        <b-form-checkbox id="is_july_freedom_fighter" v-model="fdata.is_july_freedom_fighter" name="is_july_freedom_fighter" value="1" unchecked-value="0">Gazetted July Mass Uprising Fighters</b-form-checkbox>
                                                        <b-form-checkbox id="is_disabled" v-model="fdata.is_disabled" name="is_disabled" value="1" unchecked-value="0">Disabled Individual</b-form-checkbox>
                                                    </div>
                                                </div>
                                                <div class="row mt-3">
                                                    <div class="col-md-3">
                                                        <label class="invest_head">Parent/Guardian for Disabled</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <b-form-group id="is_disabled_parent-group" label-for="is_disabled_parent">
                                                            <b-form-select id="is_disabled_parent" name="is_disabled_parent" v-model="fdata.is_disabled_parent" :options="is_disabled_parent"></b-form-select>
                                                        </b-form-group>
                                                    </div>
                                                </div>

                                               <div class="row">
                                                    <div class="col-md-3">
                                                        <label class="invest_head">e-TIN Registration Date [YYYY-MM-DD]</label>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <b-form-group id="date_of_etin-group" label-for="date_of_etin">
                                                            <b-input-group class="mb-3">
                                                                <b-form-input id="date_of_etin" name="date_of_etin" v-model="fdata.date_of_etin" v-validate="{date_format: 'yyyy-MM-dd' }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('date_of_etin')" aria-describedby="date_of_etin-feedback" data-vv-as="Date of e-TIN Registration"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-form-datepicker id="date_of_etin" :max="date_max" button-only right locale="en-US" v-model="fdata.date_of_etin"></b-form-datepicker>
                                                                </b-input-group-append>
                                                                <b-form-invalid-feedback id="date_of_etin-feedback">{{ veeErrors.first('date_of_etin') }}</b-form-invalid-feedback>
                                                            </b-input-group>   <!-- ← ADDED THIS -->
                                                        </b-form-group>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="row mt-4">
                                 <div class="col-7">
                                    <div class="card susd-card2">
                                       <div class="card-title pt-3 pb-3 pl-4 susd radius susd-head1">Profile Picture</div>
                                       <div class="card-body px-4">
                                          <div class="row">
                                                <div class="col-md-12 text-center">
                                                    <div id="employee_pic-group" role="group" class="form-group">
                                                        <div class="bv-no-focus-ring cmpny-logo-uploader">
                                                            <my-upload field="img"
                                                            @crop-success="cropSuccess"
                                                            v-model="showLogoUploader"
                                                            lang-type="en"
                                                            :width="400"
                                                            :height="400"
                                                            img-format="jpeg"></my-upload>
                                                            <img :src="logoUrl" :width="200" :height="200" @click="toggleLogoUploader" style="cursor: pointer;">
                                                            <div @click="toggleLogoUploader" class="cmpny-logo-overlay">Upload</div>
                                                        </div>
                                                    </div>
                                                </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div class="col-5">

                                 </div>
                              </div>
                            </div>

                           <div class="mt-4">

                              <b-card class="border-0 no-padding-card no-shadow text-center">
                                 <b-button v-if="new_capability" type="submit" class="rounded py-1 mt-2">Save</b-button>
                              </b-card>
                           </div>
                        </div>
                     </div>
                  </b-form>
               </div>
               </b-card>
            </div>
         </b-card>
      </b-overlay>


      <template v-if="fdata.employee_id > 0">
         <b-modal id="bv-personal-info" size="lg" hide-footer title="Employee Info">
            <b-form @submit.stop.prevent="onSubmit">
               <input type="hidden" v-model="fdata.employee_id" name="employee_id">
               <div class="clearfix">
                  <div class="text-capitalize font-weight-bold no-gutters py-2 mb-3 border-bottom">Personal Information</div>

                  <div class="row">
                     <div class="col-md-6 ">
                        <b-form-group  id="name-group" label="Full Name" class="required-field" label-for="name">
                           <b-input-group>
                              <b-form-input id="name" class="radius-8" name="name" v-model="fdata.name" :disabled="disabled" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Name">
                              </b-form-input>
                              <b-input-group-append v-if="draft_data['name']" v-b-tooltip.hover :title="xdata['name']"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                           </b-input-group>
                        </b-form-group>


                        <b-form-group id="phone-group" label="Mobile Number" class="" label-for="phone">
                           <b-input-group prepend="+880">
                              <b-form-input id="phone" name="phone" v-model="fdata.phone" v-validate="{ min: 10 , max:10 }" :state="validateState('phone')" aria-describedby="phone-feedback" data-vv-as="Contact Number"></b-form-input>
                              <b-input-group-append v-if="draft_data['phone']" v-b-tooltip.hover :title="xdata['phone']"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-form-invalid-feedback id="phone-feedback">{{ veeErrors.first('phone') }}</b-form-invalid-feedback>
                           </b-input-group>
                        </b-form-group>

                        <b-form-group  id="gender-group" label="Gender" class="required-field" label-for="gender">
                           <b-input-group>
                              <b-form-select id="gender" class="radius-8" name="gender" v-model="fdata.gender" :disabled="disabled" v-validate="{ required: true }" :options="gender" :state="validateState('gender')" aria-describedby="gender-feedback" data-vv-as="Gender"></b-form-select>
                              <b-input-group-append v-if="draft_data['gender']" v-b-tooltip.hover :title="xdata['gender']"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-form-invalid-feedback id="gender-feedback">{{ veeErrors.first('gender') }}</b-form-invalid-feedback>
                           </b-input-group>
                        </b-form-group>

                        <!-- Blood Group -->
                        <b-form-group id="blood_group_id-group" label="Blood Group" label-for="blood_group_id">
                           <b-input-group>
                              <b-form-select id="blood_group" class="radius-8" name="blood_group" v-model="fdata.blood_group" v-validate="{ required:false }" :options="bloodGroop" :state="validateState('blood_group_id')" aria-describedby="blood_group_id-feedback" data-vv-as="Blood Group"></b-form-select>
                              <b-input-group-append v-if="draft_data['blood_group']" v-b-tooltip.hover :title="xdata['blood_group']"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-form-invalid-feedback id="blood_group_id-feedback">{{ veeErrors.first('blood_group_id') }}</b-form-invalid-feedback>
                           </b-input-group>
                        </b-form-group>

                        <b-form-group  id="address-group" label="Present Address" class="required-field" label-for="address">
                           <b-input-group>
                              <b-form-textarea id="address" class="radius-8" name="address" rows="3" max-rows="6" :disabled="disabled" no-resize v-model="fdata.address" v-validate="{required: true, min: 3 }" :state="validateState('address')" aria-describedby="address-feedback" data-vv-as="Address"></b-form-textarea>
                              <b-input-group-append v-if="draft_data['address']" v-b-tooltip.hover :title="xdata['address']"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-form-invalid-feedback id="address-feedback">{{ veeErrors.first('address') }}</b-form-invalid-feedback>
                           </b-input-group>
                        </b-form-group>
                        <b-form-group  id="marital_status-group" label="Marital Status" class="" label-for="marital_status">
                           <b-input-group>
                              <b-form-select id="marital_status" name="marital_status" v-model="fdata.marital_status" :disabled="disabled" :options="marital_status" ></b-form-select>
                              <b-input-group-append v-if="draft_data['marital_status']" v-b-tooltip.hover :title="xdata['marital_status']"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                           </b-input-group>
                        </b-form-group>
                        <b-form-group  id="emergency_contact-group" label="Emergency Contact" label-for="emergency_contact">
                           <b-input-group>
                              <b-form-textarea id="emergency_contact" class="radius-8" name="emergency_contact" rows="3" max-rows="6" :disabled="disabled" no-resize v-model="fdata.emergency_contact" :state="validateState('emergency_contact')" aria-describedby="emergency_contact-feedback" data-vv-as="Emergency Contact"></b-form-textarea>
                              <b-input-group-append v-if="draft_data['emergency_contact']" v-b-tooltip.hover :title="xdata['emergency_contact']"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-form-invalid-feedback id="emergency_contact-feedback">{{ veeErrors.first('emergency_contact') }}</b-form-invalid-feedback>
                           </b-input-group>
                        </b-form-group>
                        <b-form-group  id="tax_payer-group" label="" label-for="tax_payer">
                           <b-input-group>
                              <b-form-checkbox id="is_freedom_fighter" v-model="fdata.is_freedom_fighter" name="is_freedom_fighter" value="1" unchecked-value="0">Gazetted Freedom Fighter</b-form-checkbox>
                              <b-input-group-append v-if="draft_data['is_freedom_fighter']"><b-icon icon="pencil-square" class="ml-1 mt-1"></b-icon></b-input-group-append>
                           </b-input-group>

                           <b-input-group>
                              <b-form-checkbox id="is_july_freedom_fighter" v-model="fdata.is_july_freedom_fighter" name="is_july_freedom_fighter" value="1" unchecked-value="0">Gazetted July Mass Uprising Fighters</b-form-checkbox>
                              <b-input-group-append v-if="draft_data['is_july_freedom_fighter']"><b-icon icon="pencil-square" class="ml-1 mt-1"></b-icon></b-input-group-append>
                           </b-input-group>

                           <b-input-group>
                              <b-form-checkbox id="is_disabled" v-model="fdata.is_disabled" name="is_disabled" value="1" unchecked-value="0">Disabled Individual</b-form-checkbox>
                              <b-input-group-append v-if="draft_data['is_disabled']"><b-icon icon="pencil-square" class="ml-1 mt-1"></b-icon></b-input-group-append>
                           </b-input-group>
                           <!-- <b-input-group>
                              <b-form-checkbox id="is_disabled_parent" v-model="fdata.is_disabled_parent" name="is_disabled_parent" value="1" unchecked-value="0">Disabled Parent / Legal Guardian</b-form-checkbox>
                              <b-input-group-append v-if="draft_data['is_disabled_parent']"><b-icon icon="pencil-square" class="ml-1 mt-1"></b-icon></b-input-group-append>
                           </b-input-group> -->
                        </b-form-group>

                        <!-- Updates for disable parents -->
                        <b-form-group  id="is_disabled_parent-group" label="Parent / Guardian for Each Disabled Individual" class="" label-for="is_disabled_parent">
                           <b-input-group>
                              <b-form-select id="is_disabled_parent" name="is_disabled_parent" v-model="fdata.is_disabled_parent" :disabled="disabled" :options="is_disabled_parent" ></b-form-select>
                              <b-input-group-append v-if="draft_data['is_disabled_parent']" v-b-tooltip.hover :title="xdata['is_disabled_parent']"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                           </b-input-group>
                        </b-form-group>

                        <div id="employee_pic-group" role="group" class="form-group">
                           <label id="employee_pic-group__BV_label_" for="company_logo" class="d-block">Employee Photo
                              <template v-if="draft_data['pic']">
                                 <b-link @click="downloadFileContent('/images/employee/'+ fdata.company_id + '/' + xdata['pic'])"><b-icon icon="pencil-square" class="ml-1 "></b-icon></b-link>
                                 <b-link @click="removeDraftFile('pic')">
                                    <b-icon icon="trash"  class="ml-1" v-b-tooltip.hover title="Remove Draft File"></b-icon>
                                 </b-link>
                              </template>
                           </label>
                           <div class="bv-no-focus-ring cmpny-logo-uploader">
                              <my-upload field="img"
                                 @crop-success="cropSuccess"
                                 v-model="showLogoUploader"
                                 lang-type="en"
                                 :width="400"
                                 :height="400"
                                 img-format="jpeg"></my-upload>
                              <img :src="logoUrl" :width="200" :height="200" @click="toggleLogoUploader" style="cursor: pointer;">
                              <div @click="toggleLogoUploader" class="cmpny-logo-overlay">Upload</div>
                           </div>
                        </div>
                     </div>

                     <div class="col-md-6 ">
                        <b-form-group id="email-group" label="Email Address"  class="" label-for="email">
                           <b-input-group>
                              <b-form-input id="email" name="email" class="radius-8" type="email"  v-model="fdata.email" v-validate="{ email:true}" :state="validateState('email')" aria-describedby="email-feedback" data-vv-as="Email"></b-form-input>
                              <b-input-group-append v-if="draft_data['email']" v-b-tooltip.hover :title="xdata['email']"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                           </b-input-group>
                        </b-form-group>

                        <b-form-group id="nationality-group" label="Nationality" class="required-field" label-for="nationality">
                           <b-input-group>
                              <b-form-select id="nationality" class="radius-8" name="nationality" v-model="fdata.nationality" v-validate="{ required: true }" :options="nationality" :state="validateState('nationality')" aria-describedby="nationality-feedback" data-vv-as="Nationality"></b-form-select>
                              <b-input-group-append v-if="draft_data['nationality']" v-b-tooltip.hover :title="xdata['nationality']"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-form-invalid-feedback id="nationality-feedback">{{ veeErrors.first('nationality') }}</b-form-invalid-feedback>
                           </b-input-group>
                        </b-form-group>

                        <input type="hidden" v-model="fake"/>


                        <b-form-group id="date_of_birth-group" class="required-field" label="Date of Birth [YYYY-MM-DD]" label-for="date_of_birth">
                           <b-input-group class="mb-3">
                             <b-form-input id="date_of_birth" v-model="fdata.date_of_birth" type="text" placeholder="YYYY-MM-DD" autocomplete="off" @change="onContext" :state="validateState('date_of_birth')" aria-describedby="date_of_birth-feedback" data-vv-as="Date of Birth"></b-form-input>
                                <b-input-group-prepend>
                                    <b-form-datepicker v-model="fdata.date_of_birth" :max="date_max" button-only right locale="en-US" aria-controls="example-input" @context="onContext"></b-form-datepicker>
                                    <span v-if="draft_data['date_of_birth']" v-b-tooltip.hover :title="xdata['date_of_birth']"><b-icon icon="pencil-square" class="ml-1 mt-2" ></b-icon></span>
                                </b-input-group-prepend>
                                <b-form-invalid-feedback id="date_of_birth-feedback">{{ veeErrors.first('date_of_birth') }}</b-form-invalid-feedback>
                           </b-input-group>
                        </b-form-group>




                        <b-form-group id="residency-group" label="Residency" class="required-field" label-for="residency">
                           <b-input-group>
                              <b-form-select id="residency" class="radius-8" name="residency" v-model="fdata.residency" v-validate="{ required: true }" :options="residency" :state="validateState('residency')" aria-describedby="residency-feedback" data-vv-as="Residency"></b-form-select>
                              <b-input-group-append v-if="draft_data['residency']" v-b-tooltip.hover :title="xdata['residency']"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-form-invalid-feedback id="residency-feedback">{{ veeErrors.first('residency') }}</b-form-invalid-feedback>
                           </b-input-group>
                        </b-form-group>


                        <!-- NID -->
                        <b-form-group id="nid-group" label="NID No." class="" label-for="nid">
                           <b-input-group>
                              <b-form-input id="nid" name="nid" v-model="fdata.nid" ></b-form-input>
                              <b-input-group-append v-if="draft_data['nid']" v-b-tooltip.hover :title="xdata['nid']"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                           </b-input-group>
                        </b-form-group>
                        <div class="row">
                           <div :class="xdata.nid_scan == '' ? 'col-sm-12' : 'col-sm-10'"> <!-- Mustafijur: 17-05-2026 -->
                              <b-form-group id="form_nid_scan-group" label="Scanned copy of NID No." label-for="form_nid_scan">
                                 <b-input-group>
                                    <b-form-file @change="checkFileType($event , 'form_nid_scan' , ['.jpg','.png','.gif','.pdf'])" id="form_nid_scan" v-model="form_nid_scan" accept=".jpg, .png, .gif, .pdf"  placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." aria-describedby="form_nid_scan-feedback" data-vv-as="Scanned copy of NID No."></b-form-file>

                                 </b-input-group>
                              </b-form-group>
                           </div>

                           <div class="col-sm-2 mx-0 px-0 align-self-center mt-2" v-if="draft_data['nid_scan']">
                              <b-link @click="downloadFileContent('/images/employee/'+ fdata.company_id + '/draft/' + fdata.nid_scan)">
                                 <b-icon icon="pencil-square" v-b-tooltip.hover title="Draft File"></b-icon>
                              </b-link>
                              <b-link @click="removeDraftFile('nid_scan')">
                                 <b-icon icon="trash"  class="ml-1" v-b-tooltip.hover title="Remove Draft File"></b-icon>
                              </b-link>
                              <b-link v-if="xdata.nid_scan" @click="downloadFileContent('/images/employee/'+ fdata.company_id + '/' + xdata.nid_scan)">
                                 <b-icon icon="download" class="ml-1" v-b-tooltip.hover title="Existing File"></b-icon>
                              </b-link>
                           </div>

                           <div class="col-sm-2 align-self-center mt-2" v-else-if="xdata.nid_scan">
                              <b-link @click="downloadFileContent('/images/employee/'+ fdata.company_id + '/' + xdata.nid_scan)">
                                 <b-icon icon="download" scale="2"></b-icon>
                              </b-link>
                           </div>
                        </div>

                        <!-- Passport -->
                        <b-form-group id="passport-group" label="Passport No." class="" label-for="passport">
                           <b-input-group>
                              <b-form-input id="passport" name="passport" v-model="fdata.passport" ></b-form-input>
                              <b-input-group-append v-if="draft_data['passport']" v-b-tooltip.hover :title="xdata['passport']"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                           </b-input-group>
                        </b-form-group>
                        <div class="row">
                           <div :class="xdata.passport_scan == '' ? 'col-sm-12' : 'col-sm-10'">
                              <b-form-group id="form_passport_scan-group" label="Scanned copy of Passport No." label-for="form_passport_scan">
                                 <b-input-group>
                                    <b-form-file @change="checkFileType($event , 'form_passport_scan' , ['.jpg','.png','.gif','.pdf'])" id="form_passport_scan" v-model="form_passport_scan" accept=".jpg, .png, .gif, .pdf"  placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." aria-describedby="form_passport_scan-feedback" data-vv-as="Scanned copy of Passport No."></b-form-file>

                                 </b-input-group>
                              </b-form-group>
                           </div>

                           <div class="col-sm-2 mx-0 px-0 align-self-center mt-2" v-if="draft_data['passport_scan']">
                              <b-link @click="downloadFileContent('/images/employee/'+ fdata.company_id + '/draft/' + fdata.passport_scan)">
                                 <b-icon icon="pencil-square" v-b-tooltip.hover title="Draft File"></b-icon>
                              </b-link>
                              <b-link @click="removeDraftFile('passport_scan')">
                                 <b-icon icon="trash"  class="ml-1" v-b-tooltip.hover title="Remove Draft File"></b-icon>
                              </b-link>
                              <b-link v-if="xdata.passport_scan" @click="downloadFileContent('/images/employee/'+ fdata.company_id + '/' + xdata.passport_scan)">
                                 <b-icon icon="download"  class="ml-1" v-b-tooltip.hover title="Existing File"></b-icon>
                              </b-link>
                           </div>

                           <div class="col-sm-2 align-self-center mt-2" v-else-if="xdata.passport_scan">
                              <b-link @click="downloadFileContent('/images/employee/'+ fdata.company_id + '/' + xdata.passport_scan)">
                                 <b-icon icon="download" scale="2"></b-icon>
                              </b-link>
                           </div>
                        </div>

                        <!-- eTIN -->
                        <b-form-group id="etin-group" label="e-TIN Number" label-for="etin">
                           <b-input-group>
                              <b-form-input id="etin" class="radius-8" name="etin" v-model="fdata.etin" v-validate="{min: 12 , max:12}" :state="validateState('etin')" aria-describedby="etin-feedback" data-vv-as="eTin"></b-form-input>
                              <b-input-group-append v-if="draft_data['etin']" v-b-tooltip.hover :title="xdata['etin']"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-form-invalid-feedback id="etin-feedback">{{ veeErrors.first('etin') }}</b-form-invalid-feedback>
                           </b-input-group>
                        </b-form-group>
                        <div class="row">
                           <div :class="xdata.etin_scan == '' ? 'col-sm-12' : 'col-sm-10'"> <!-- Mustafijur: 17-05-2026 -->
                              <b-form-group id="form_etin_scan-group" label="Scanned copy of e-TIN" label-for="form_etin_scan">
                                 <b-input-group>
                                    <b-form-file @change="checkFileType($event , 'form_etin_scan' , ['.jpg','.png','.gif','.pdf'])" id="form_etin_scan" v-model="form_etin_scan" accept=".jpg, .png, .gif, .pdf"  placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." aria-describedby="form_etin_scan-feedback" data-vv-as="Scanned copy of eTIN"></b-form-file>

                                 </b-input-group>
                              </b-form-group>
                           </div>

                           <div class="col-sm-2 mx-0 px-0 align-self-center mt-2" v-if="draft_data['etin_scan']">
                              <b-link @click="downloadFileContent('/images/employee/'+ fdata.company_id + '/draft/' + fdata.etin_scan)">
                                 <b-icon icon="pencil-square" v-b-tooltip.hover title="Draft File"></b-icon>
                              </b-link>
                              <b-link @click="removeDraftFile('etin_scan')">
                                 <b-icon icon="trash"  class="ml-1" v-b-tooltip.hover title="Remove Draft File"></b-icon>
                              </b-link>

                              <b-link v-if="xdata.etin_scan" @click="downloadFileContent('/images/employee/'+ fdata.company_id + '/' + xdata.etin_scan)">
                                 <b-icon icon="download"  class="ml-1" v-b-tooltip.hover title="Existing File"></b-icon>
                              </b-link>
                           </div>

                           <div class="col-sm-2 align-self-center mt-2" v-else-if="xdata.etin_scan">
                              <b-link @click="downloadFileContent('/images/employee/'+ fdata.company_id + '/' + xdata.etin_scan)">
                                 <b-icon icon="download" scale="2"></b-icon>
                              </b-link>
                           </div>
                        </div>

                        <b-form-group id="date_of_etin-group" label="e-TIN Registration Date [YYYY-MM-DD]" class="" label-for="date_of_etin">
                           <b-input-group class="mb-3">
                              <b-form-input id="date_of_etin" name="date_of_etin" v-model="fdata.date_of_etin" v-validate="{date_format: 'yyyy-MM-dd' }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('date_of_etin')" aria-describedby="date_of_etin-feedback" data-vv-as="Date of e-TIN Registration"></b-form-input>
                              <!-- Mustafijur: file validation change on line 391  -->
                              <b-input-group-append>
                                 <b-form-datepicker id="date_of_etin" :max="date_max" button-only right locale="en-US" v-model="fdata.date_of_etin"></b-form-datepicker>
                              </b-input-group-append>
                              <b-form-invalid-feedback id="date_of_etin-feedback">{{ veeErrors.first('date_of_etin') }}</b-form-invalid-feedback>
                           </b-input-group>
                        </b-form-group>


                           <!-- Religion -->
                        <b-form-group id="religion-group" label="Religion" label-for="Religion">
                           <b-input-group>
                              <b-form-select id="religion" class="radius-8" name="religion" v-model="fdata.religion" v-validate="{ required:false }" :options="religion" :state="validateState('religion')" aria-describedby="religion-feedback" data-vv-as="Religion"></b-form-select>
                              <b-input-group-append v-if="draft_data['religion']" v-b-tooltip.hover :title="xdata['religion']"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-form-invalid-feedback id="religion-feedback">{{ veeErrors.first('religion') }}</b-form-invalid-feedback>
                           </b-input-group>
                        </b-form-group>

                        <!-- Disability -->
                        <b-form-group  id="name-group" label="Disability" label-for="Disability" >
                           <b-input-group>
                              <b-form-input id="disability" class="radius-8" name="disability" v-model="fdata.disability" placeholder="Write disability" v-validate="{ required: false}" :state="validateState('disability')" aria-describedby="disability-feedback" data-vv-as="Disability"></b-form-input>
                              <b-input-group-append v-if="draft_data['disability']" v-b-tooltip.hover :title="xdata['disability']"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-form-invalid-feedback id="disability-feedback">{{ veeErrors.first('disability') }}</b-form-invalid-feedback>
                           </b-input-group>
                        </b-form-group>

                     </div>
                  </div>
               </div>

               <div class="clearfix">
                  <div class="text-capitalize font-weight-bold no-gutters py-2 mb-3 border-bottom">HR Information</div>
                  <div class="row">
                     <div class="col-md-6 ">
                        <b-form-group id="department_id-group" label="Department" class="" label-for="department_id">
                           <b-input-group>
                              <b-form-select id="department_id" name="department_id" v-model="fdata.department_id" :disabled="disabled_edit" :options="department" ></b-form-select>
                              <b-input-group-append v-if="draft_data['department_id'] && (xdata.department_id != 0)" v-b-tooltip.hover :title="department.find(department => department.id === xdata['department_id']).text"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-input-group-append v-else-if="draft_data['department_id']" ><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                           </b-input-group>
                        </b-form-group>
                        <b-form-group id="employee_type_id-group" label="Employee Type" class="" label-for="employee_type_id">
                           <b-input-group>
                              <b-form-select id="employee_type_id" name="employee_type_id" v-model="fdata.employee_type_id" :disabled="disabled_edit" :options="employee_type" ></b-form-select>
                              <b-input-group-append v-if="draft_data['employee_type_id'] && (xdata.employee_type_id != 0)" v-b-tooltip.hover :title="employee_type.find(type => type.value === xdata['employee_type_id']).text"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-input-group-append v-else-if="draft_data['employee_type_id']" ><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                           </b-input-group>
                        </b-form-group>
                        <b-form-group id="jobposition_id-group" label="Job Position" class="" label-for="jobposition_id">
                           <b-input-group>
                              <b-form-select id="jobposition_id" name="jobposition_id" v-model="fdata.jobposition_id" :disabled="disabled_edit" :options="jobposition"></b-form-select>
                              <b-input-group-append v-if="draft_data['jobposition_id'] && (xdata.jobposition_id != 0)" v-b-tooltip.hover :title="jobposition.find(jobposition => jobposition.id === xdata['jobposition_id']).text"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-input-group-append v-else-if="draft_data['jobposition_id']"> <b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                           </b-input-group>
                        </b-form-group>
                        <b-form-group id="branch_id-group" label="Work Location" class="" label-for="branch_id">
                           <b-input-group>
                              <b-form-select id="branch_id" name="branch_id" v-model="fdata.branch_id" :options="branch"></b-form-select>
                              <b-input-group-append v-if="draft_data['branch_id'] && (xdata.jobposition_id != 0)" v-b-tooltip.hover :title="branch.find(branch => branch.id === xdata['branch_id']).text"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-input-group-append v-else-if="draft_data['branch_id']" ><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                           </b-input-group>
                        </b-form-group>

                        <!-- I am not sure if date fo joining can be altered from here -->
                        <b-form-group id="date_of_joining-group" label="Joining Date [YYYY-MM-DD]" label-for="date_of_joining">
                           <b-input-group class="mb-3">
                            <b-form-input id="date_of_joining" v-model="fdata.date_of_joining" type="text" placeholder="YYYY-MM-DD" autocomplete="off" @change="onContext"></b-form-input>
                              <b-input-group-prepend>
                                 <b-form-datepicker v-model="fdata.date_of_joining" button-only right locale="en-US" aria-controls="example-input" @context="onContext"></b-form-datepicker>
                                 <span v-if="draft_data['date_of_joining']" v-b-tooltip.hover :title="xdata['date_of_joining']"><b-icon icon="pencil-square" class="ml-1 mt-2" ></b-icon></span>
                              </b-input-group-prepend>


                           </b-input-group>
                        </b-form-group>
                     </div>
                     <div class="col-md-6 ">
                        <b-form-group id="manager_id-group" label="Reporting Manager" label-for="manager_id">
                           <b-input-group>
                              <b-form-select id="manager_id" name="manager_id" v-model="fdata.manager_id" :options="manager"></b-form-select>
                              <b-input-group-append v-if="draft_data['manager_id'] && (xdata.manager_id != 0)" v-b-tooltip.hover :title="manager.find(manager => manager.value === xdata['manager_id']).text"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-input-group-append v-else-if="draft_data['manager_id']" ><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                           </b-input-group>
                        </b-form-group>

                        <b-form-group id="employee_code-group" label="Employee Code" label-for="employee_code">
                           <b-input-group>
                              <b-form-input id="employee_code" class="radius-8" name="employee_code" v-model="fdata.employee_code" v-validate="{  min: 3 }" :state="validateState('employee_code')" aria-describedby="employee_code-feedback" data-vv-as="Employee Code"></b-form-input>
                              <b-input-group-append v-if="draft_data['employee_code']" v-b-tooltip.hover :title="xdata['employee_code']"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-form-invalid-feedback id="employee_code-feedback">{{ veeErrors.first('employee_code') }}</b-form-invalid-feedback>
                           </b-input-group>
                        </b-form-group>
                        <!-- <b-form-group id="leave_policy_id-group" label="Leave Policy" class="" label-for="leave_policy_id">
                           <b-input-group>
                              <b-form-select id="leave_policy_id" name="leave_policy_id" v-model="fdata.leave_policy_id" :options="leave_policies" :disabled="disabled_edit" ></b-form-select>
                              <b-input-group-append v-if="draft_data['leave_policy_id'] && (xdata.leave_policy_id != 0)" v-b-tooltip.hover :title="leave_policies.find(leave_policies => leave_policies.value === xdata['leave_policy_id']).text"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-input-group-append v-else-if="draft_data['leave_policy_id']" ><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                           </b-input-group>
                        </b-form-group> -->
                        <!-- asfaq 21 june 2026 -->
                        <b-form-group id="leave_policy_id-group" label="Leave Policy" class="" label-for="leave_policy_id" v-if="addons.includes('LeaveAttendances')">
                           <b-input-group>
                              <b-form-select id="leave_policy_id" name="leave_policy_id" v-model="fdata.leave_policy_id" :options="leave_policies" :disabled="disabled_edit" ></b-form-select>
                              <b-input-group-append v-if="draft_data['leave_policy_id'] && (xdata.leave_policy_id != 0)" v-b-tooltip.hover :title="leave_policies.find(leave_policies => leave_policies.value === xdata['leave_policy_id']).text"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-input-group-append v-else-if="draft_data['leave_policy_id']" ><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                           </b-input-group>
                        </b-form-group>
                        <b-form-group id="roster_leave_policy_id-group" label="Leave Policy" class="" label-for="roster_leave_policy_id" v-if="addons.includes('Roster')">
                           <b-input-group>
                              <b-form-select id="roster_leave_policy_id" name="roster_leave_policy_id" v-model="fdata.roster_leave_policy_id" :options="roster_leave_policies" :disabled="disabled_edit"></b-form-select>
                              <b-input-group-append v-if="draft_data['roster_leave_policy_id'] && (xdata.roster_leave_policy_id != 0)" v-b-tooltip.hover :title="roster_leave_policies.find(roster_leave_policies => roster_leave_policies.value === xdata['roster_leave_policy_id']).text"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                              <b-input-group-append v-else-if="draft_data['roster_leave_policy_id']" ><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                           </b-input-group>
                        </b-form-group>
                        <!-- asfaq 21 june 2026 -->


                     </div>
                     <div class="btn-wrapper text-center pt-5 col-md-12">
                        <b-button type="submit" class="" variant="primary" >Submit</b-button>
                        <template v-if="hasDraft">
                            <b-button v-if="permission == 2" type="button" class="custom-wizard-btn" variant="primary" @click="clearDraft()">Reset</b-button>
                        </template>
                    </div>
                  </div>

               </div>

            </b-form>
         </b-modal>
      </template>

   </div>
</template>
<script>
   import myUpload from 'vue-image-crop-upload';
   import moment from 'moment';

   export default{

      mounted() {
         //console.log('login form info started..');
         if(this.employeedata.date_of_birth == '0000-00-00')
            this.fdata.date_of_birth = '';

         if(this.employeedata.last_working_day == '0000-00-00')
            this.fdata.last_working_day = '';

         this.showoverlay = false;

         this.permission = this.$acl['employee/info'];

         if(this.employeedata.date_of_etin == '0000-00-00')
            this.fdata.date_of_etin = '';
      },
      components: {
         'my-upload': myUpload
      },
   data(){

         const now = new Date()
         const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
         const maxDate = new Date(today);
         return {
            date_max:maxDate,
            cu:window.location.href,
            successmsg : false,
            warningmsg : false,
            dangermsg : false,
            showoverlay : true,

            readonly : false,
            trz_display_form : 'd-none',
            user_level : 0,
            has_changed : false,
            reset_flg : false,
            has_changed_flg : false,

            disableme : false,
            disabled : false,
            disabled_edit : true,

            formatted: '',
            selected: '',
            fake : 0,

            date_of_birth : '',
            date_of_etin : '',
            date_of_joining : '',

            errormsg:[],

            tdata:{},
            // fdata: {employee_id:0 , department_id:0, jobposition_id:0, branch_id:0, manager_id:0, leave_policy_id:0 , gender:null, marital_status:null, nationality:null, residency:null, nationality:null,  blood_group:null, religion:null},
            fdata: {employee_id:0 , department_id:0, jobposition_id:0, branch_id:0, employee_type_id:0, manager_id:0, leave_policy_id:0 , gender:null, marital_status:null, nationality:null, residency:null, blood_group:null, religion:null, is_freedom_fighter:'0', is_july_freedom_fighter:'0', is_disabled:'0', is_disabled_parent:null, date_of_etin:''},
            xdata : {},

            employeedata:[],
            edit_user:false,
            new_capability:true,

            department : [],
            employee_type : [],
            jobposition : [],
            branch : [],
            manager : [],
            leave_policies : [],
            roster_leave_policies : [],
            addons: [],

            nationality : [],

            employee_pic : '',
            form_pic:null,
            form_nid_scan:null,
            form_passport_scan:null,
            form_etin_scan:null,
            this_employee_id: 0,


            residency: [
                  { value: null, text: "Select..." },
                  { value: "Resident", text: "Resident" },
                  { value: "Non Resident", text: "Non Resident" },
                  { value: "Resident Expatriate", text: "Resident Expatriate" }
            ],
            gender:[
                  { value: null, text: "Select..." },
                  { value: "Male", text: "Male" },
                  { value: "Female", text: "Female" },
                  { value: "Third Gender", text: "Third Gender" },
            ],
            marital_status:[
                  { value: null, text: "Select..." },
                  { value: "Single", text: "Single" },
                  { value: "Married", text: "Married" },
                  { value: "Widower", text: "Widower" },
                  { value: "Divorced", text: "Divorced" },
            ],

            is_disabled_parent:[
                  { value: null, text: "Select..." },
                  { value: "1", text: "1" },
                  { value: "2", text: "2" },
                  { value: "3", text: "3" },
                  { value: "4", text: "4" },
                  { value: "5", text: "5" },
            ],

            bloodGroop:
            [
               {value: null, text: "Select..."},
               {value: 'A+', text: "A+"},
               {value: 'A-', text: "A-"},
               {value: 'B+', text: "B+"},
               {value: 'B-', text: "B-"},
               {value: 'O+', text: "O+"},
               {value: 'O-', text: "O-"},
               {value: 'AB+', text: "AB+"},
               {value: 'AB-', text: "AB-"},
            ],

            religion:
            [
               {value: null, text: "Select..."},
               {value: 'Islam', text: "Islam"},
               {value: 'Hinduism', text: "Hinduism"},
               {value: 'Buddhism', text: "Buddhism"},
               {value: 'Christianity', text: "Christianity"},
               {value: 'Judaism', text: "Judaism"},
               {value: 'Others', text: "Others"},
               {value: 'I prefer not to disclose', text: "I prefer not to disclose"},
            ],

            bankurl : this.$api_url+'/bankinfo/',

            logoUrl : this.$api_url + '/images/employee/' + 'demo.jpg',
            logoUploaded: false,
            showLogoUploader: false,



            showoverlay_list : false,

            draft_data : [],
            hasDraft  : false,
            draft_employee : false,

            permission : 0,


         }
      },
      methods:{

         showMessage: function()
         {
            let childdata = {employee_id:this.fdata.employee_id , draft_flg:this.fdata.draft_flg , draft_mph:this.fdata.draft_mph , draft_mpfh:this.fdata.draft_mpfh , draft_contract:this.fdata.draft_contract , status:this.fdata.status , successmsg:this.successmsg , warningmsg:this.warningmsg , dangermsg:this.dangermsg};
            this.$emit('childToParent', childdata);
         },
         onContext(ctx) {
            // The date formatted in the locale, or the `label-no-date-selected` string
            //this.formatted = ctx.selectedFormatted;
            // The following will be an empty string until a valid date is entered
            //this.selected = ctx.selectedYMD;
            this.fake = this.fake + 1;
         },
         trz_display: function()
         {
            this.$bvModal.show('bv-personal-info');
         },
         trz_display_hr_info: function()
         {
            //this.$bvModal.show('bv-hr-info');
            this.$bvModal.show('bv-personal-info');
         },
         toggleLogoUploader() {
            this.showLogoUploader = !this.showLogoUploader;
         },
         cropSuccess(imgDataUrl, field){

         this.logoUrl = imgDataUrl;
                     this.logoUploaded = true;
         },
         clearDraft: function(field = 'all')
         {
            let currentObj = this;
            let formData = new FormData();

            formData.append('field', field);
            axios.post(this.$api_url+'/employee/draft/clear', formData)
                                .then(function (response)
                                {

                                    this.$bvToast.toast('All draft data has been cleard.', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                                    this.getDraftData();

                                }.bind(this))
                                .catch(function (error)
                                {
                                    currentObj.serverError(error);
                                });
         },
         removeDraftFile: function(x)
         {
            if(x == 'pic')
            {
               this.logoUrl = this.$api_url+'/avatar/'+ this.fdata.company_id + '/' + this.xdata.pic;
            }
            else
               this.draft_data[x] = null;
            this.clearDraft(x);
         },
         getDraftData: function()
         {

            if(!this.checkNet()) return false;
            let currentObj = this;

            this.showoverlay = true;

            axios.get(this.$api_url+'/employee/draft')
                  .then(function (response) {

                     this.draft_data = response.data;
                     this.showoverlay = false;

                     for (let [key, value] of Object.entries(this.draft_data))
                     {
                        //this.xdata[key] = value;
                        this.fdata[key] = value;
                     }

                     if(this.draft_data.pic)
                        this.logoUrl = this.$api_url+'/avatar/'+ this.fdata.company_id + '/draft/' + this.draft_data.pic;


                     if(this.draft_data.phone)
                     {
                        let p = this.draft_data.phone;
                        this.fdata.phone = p.slice(3,15);
                     }

                     this.form_pic = null;
                     this.form_nid_scan = null;
                     this.form_etin_scan = null;
                     this.form_passport_scan = null;


                     if(Object.keys(this.draft_data).length > 0)
                     {
                        /*this.$bvToast.toast("This form has some draft data", {
                                    title: `Info`,
                                    variant: 'info',
                                    solid: true,
                                    toaster: 'b-toaster-bottom-full',
                                 });*/
                        this.hasDraft = true;
                     }
                     else
                     {
                        this.hasDraft = false;
                     }

                  }.bind(this)).catch(function (error){ currentObj.serverError(error); });
         },
         getEmployee: function(reset = 0 , flg = 1)
         {
            if(!this.checkNet()) return false;
            let currentObj = this;

            this.showoverlay = true;

            //axios.get(this.$api_url+'/employee/details?flg='+flg+'&reset='+reset)
            axios.get(this.$api_url+'/employee/details')
                  .then(function (response) {
                     if(response.data.employee_id > 0)
                     {
                     //this.disabled_edit = true;
                        for (let [key, value] of Object.entries(response.data))
                        {
                              this.xdata[key] = value;
                              this.fdata[key] = value;
                        }


                        if((response.data.phone != null) && (response.data.phone != ''))
                        {
                              let p = response.data.phone;
                              this.fdata.phone = response.data.phone.slice(3,15);
                              this.xdata.phone = p.slice(3,15);
                        }

                        this.date_of_birth = moment(String(response.data.date_of_birth)).format('D MMMM YYYY');
                        this.date_of_etin = moment(String(response.data.date_of_etin)).format('D MMMM YYYY');
                        this.date_of_joining = moment(String(response.data.date_of_joining)).format('D MMMM YYYY');


                        this.logoUrl = this.$api_url+'/avatar/'+ this.fdata.company_id + '/' + this.fdata.pic;
                        this.disableme = true;
                        this.showMessage();

                        if(this.fdata.email == 'null'){ this.fdata.email = ''; this.xdata.email = ''; }
                        if(this.fdata.passport == 'null'){ this.fdata.passport = ''; this.xdata.passport = ''; }
                        if(this.fdata.emergency_contact == 'null'){ this.fdata.emergency_contact = ''; this.xdata.emergency_contact = ''; }
                        if(this.fdata.employee_code == 'null'){ this.fdata.employee_code = ''; this.xdata.employee_code = ''; }
                        if(this.fdata.etin == 'null'){ this.fdata.etin = ''; this.xdata.etin = ''; }
                        if(this.fdata.marital_status == 'null'){ this.fdata.marital_status = ''; this.xdata.marital_status = ''; }


                        this.edit_user = true;

                        if(this.fdata.draft_flg == 1)
                        {
                           this.has_changed_flg = true;
                           this.reset_flg = true;
                        }

                        if(this.fdata.draft_employee == 1)
                        {
                           this.draft_employee = true;
                        }




                        if(reset == 1)
                        {
                              this.reset_flg = false;
                              this.has_changed_flg = true;
                        }


                        this.logoUploaded = null;
                        this.form_pic = null;
                        this.form_nid_scan = null;
                        this.form_etin_scan = null;
                        this.form_passport_scan = null;

                        this.new_capability = true;
                        this.errormsg = [];
                        //this.$validator.reset();

                        this.readonly = true;
                        this.trz_display_form = 'd-none';

                        this.getDraftData();
                     }
                     else
                     {
                        if(response.data.capability==false){
                        this.new_capability = false;
                        this.errormsg = [];
                        this.errormsg[0] = ["You are not allowed to add more employee!!!"];
                        }
                        else{

                        this.readonly = false;
                        this.trz_display_form = '';

                        this.new_capability = true;
                        this.errormsg = [];
                        //this.$bvModal.show('bv-personal-info');
                        }

                     }

                     this.showoverlay = false;

                  }.bind(this)).catch(function (error){ currentObj.serverError(error); });
         },


         getCountryData: function()
         {
            if(!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url+'/countries/' , {
                  params: {

                  }
            }).then(function(response){
                  this.nationality = response.data;
            }.bind(this)).catch(function (error){currentObj.serverError(error);});
         },

         getDepartments: function(){
            axios.get(this.$api_url+'/department/list')
            .then(function (response) {
                  this.department = [{ value: 0, text: "Select..." } ] . concat(response.data);
            }.bind(this));

         },
         getEmployeeTypes: function(){
            axios.get(this.$api_url+'/employeetype/list')
            .then(function (response) {
                  this.employee_type = [{ value: 0, text: "Select..." } ] . concat(response.data);
            }.bind(this));

         },
         getJobPosition: function() {
            axios.get(this.$api_url+'/jobposition/options').then(function(response)
            {
               this.jobposition = [{ value: 0, text: "Select..." } ] . concat(response.data);
            }.bind(this));
         },

         getBranches: function(){
            axios.get(this.$api_url+'/branch/list')
            .then(function (response) {
                  this.branch = [{ value: 0, text: "Select..." } ] . concat(response.data);
            }.bind(this));
         },

         getLeavePolicies: function(){
            axios.get(this.$api_url+'/leave/policy/list')
            .then(function (response) {
                  this.leave_policies = [{ value: 0, text: "Select..." } ] . concat(response.data);
            }.bind(this));
         },


         getManagers: function(){
            axios.get(this.$api_url+'/manager')
            .then(function (response) {
                  this.manager = [{ value: 0, text: "Select..." } ] . concat(response.data);
            }.bind(this));
         },


         resetForm()
         {
            this.fdata = {employee_id:0 , department_id:0, jobposition_id:0, branch_id:0, employee_type_id:0, manager_id:0, leave_policy_id:0 , blood_group:'', religion:''};
            this.reset_flg = true;
            this.$nextTick(() => {
                  this.$validator.reset();
            });
         },
         getRosterLeavePolicies: function(){
            axios.get(this.$api_url+'/leave-attendance/leave/policy/list')
            .then(function (response) {
                  this.roster_leave_policies = [{ value: 0, text: "Select..." } ] . concat(response.data);
            }.bind(this));
         },
         getCompanyData:function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/details' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){

                    if(response.data.length != 0)
                    {
                        this.addons =  response.data.module_disabled;
                    }
                }.bind(this));
            },
         onSubmit(e)
         {
            if(!this.checkNet()) return false;

            this.has_changed = false;
            let changed = false;

            this.$validator.validateAll().then(result => {
               if (!result)
               {
                  this.$bvToast.toast("Please fill all required fields [marked red]", {
                                       title: `Error`,
                                       variant: 'danger',
                                       solid: true
                                 });

                  return;
               }



               e.preventDefault();
               let currentObj = this;
               currentObj.errormsg = '';
               const config = {
                  headers: { 'content-type': 'multipart/form-data' }
               }

               let formData = new FormData();

               if(this.logoUploaded)
               {
                  changed = true;
                  formData.append('form_pic', this.logoUrl);
               }


               if(this.form_nid_scan)
               {
                  changed = true;
                  formData.append('form_nid_scan', this.form_nid_scan);
               }


               if(this.form_etin_scan)
               {
                  changed = true;
                  formData.append('form_etin_scan', this.form_etin_scan);
               }



               if(this.form_passport_scan)
               {
                  changed = true;
                  formData.append('form_passport_scan', this.form_passport_scan);
               }





               if(this.fdata.employee_id == 0)
               {
                  for (let [key, value] of Object.entries(this.fdata))
                  {
                     var nm = `${key}`;
                     var fval = `${value}`;
                     if(fval == 'null')
                        fval = '';
                     formData.append(nm, fval);
                     //console.log(`${key}: ${value}`);
                  }
               }
               else
               {
                  let changed_data = [];
                  for (let [key, value] of Object.entries(this.fdata))
                  {
                     var nm = `${key}`;
                     var fval = `${value}`;
                     if(fval == 'null')
                        fval = '';

                     if((this.fdata[key] != this.xdata[key]))
                     {
                        changed_data = changed_data.concat([{ field: nm , value: fval }]);
                        changed = true;
                     }
                  }

                  if(changed == false)
                  {
                     this.$bvToast.toast('No changed data found.', {
                                       title: `Warning`,
                                       variant: 'warning',
                                       solid: true
                                 });


                     return;
                  }



                  formData.append('changed_data', JSON.stringify(changed_data));

                  formData.append('employee_id', this.fdata.employee_id);
               }

               this.showoverlay = true;

               axios.post(this.$api_url+'/employee/account', formData, config)
                           .then(function (response)
                           {

                              this.showoverlay = false;

                              if(response.data.status == 0)
                              {
                                 this.resetForm();

                                 for (let [key, value] of Object.entries(currentObj.xdata))
                                 {
                                    //this.xdata[key] = value;
                                    currentObj.fdata[key] = value;
                                 }
                                 this.$bvToast.toast(response.data.msg, {
                                       title: `error`,
                                       variant: 'danger',
                                       solid: true
                                 });

                              }
                              else
                              {
                                 this.$bvToast.toast("Saved!", {
                                       title: `Success`,
                                       variant: 'success',
                                       solid: true
                                 });
                                 this.getEmployee(1,1);

                                 this.$bvModal.hide('bv-hr-info');
                                 this.$bvModal.hide('bv-personal-info');
                              }


                           }.bind(this))
                           .catch(function (error)
                           {
                              currentObj.showoverlay = false;
                              currentObj.serverError(error);

                           });
            });
         },



      },
      created: function(){
         if(!this.checkNet()) return false;

         //this.getUserLevel();
         this.getDepartments();
         this.getEmployeeTypes();
         this.getJobPosition();
         this.getBranches();
         this.getLeavePolicies();
         this.getManagers();

         this.getRosterLeavePolicies(); // asfaq 21 june 2026
         this.getCompanyData(); // asfaq 21 june 2026

         this.getCountryData();

         this.getEmployee();
         //this.$validator.reset();
      }
   }
</script>
